<template>
  <lm-help-tip class="ml-2"
    >When a topic is marked as <span class="text-gray-900">Important</span> all
    users of the Landscape will be notified in the
    <span class="italic">Notifications</span> panel.<br />It is also possible to
    filter the Topics list to show only
    <span class="text-gray-900">Important topics</span>.
  </lm-help-tip>
</template>

<script>
import LmHelpTip from '@/components/ui/LmHelpTip'
export default {
  name: 'ImportantHelp',
  components: {LmHelpTip}
}
</script>
